function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex';
import Somos1Service from '@/apps/customer-insigths/services/somos1_service';
import AgreementsComponent from '@/components/AgreementsComponent.vue';
import TokenComponent from '@/components/TokenComponent.vue';
import SecurityService from '@/apps/data-platform/services/security/user_security_service';
import tasks from '@/js/tasks';
import { firebaseConfig, GA_EVENTS, ROLES_LIST, ORGS } from '@/js/constants';
import { mapState } from 'vuex';
export default {
  name: 'CompaniesReportListPage',
  components: {
    AgreementsComponent: AgreementsComponent,
    TokenComponent: TokenComponent
  },
  data: function data() {
    return {
      keyDashboardsList: 0,
      items: [],
      headers: [{
        value: 'report.name',
        text: 'Nombre'
      }, {
        value: 'report.organization.name',
        text: 'Empresa'
      }, {
        value: 'report.description',
        text: 'Descripción'
      }, {
        value: 'report.region.region',
        text: 'Región'
      }, {
        value: 'actions',
        text: ''
      }],
      send_token: false,
      has_accepted: userInfo.somos1_agreement,
      agreement_text: '',
      color: 'custom',
      decline: false,
      company_code: '',
      EMPRESAS: 'Empresas',
      company_name: ''
    };
  },
  created: function created() {
    var _this = this;
    this.company_code = this.$route.query.company_code;
    this.company_name = ORGS.find(function (objeto) {
      return objeto.code === _this.$route.query.company_code;
    }).empresa;
    console.log('this.company_code', this.company_code);
    this.getReports();
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode', 'companyName'])), {}, {
    getBreadcrumbs: function getBreadcrumbs() {
      var _this2 = this;
      return [{
        text: this.translate('menu.customer.somos1_reports'),
        disabled: false,
        href: '/#/customer_insights/companies'
      }, {
        text: ORGS.find(function (objeto) {
          return objeto.code === _this2.$route.query.company_code;
        }).empresa,
        disabled: true
      }];
    },
    getClassTable: function getClassTable() {
      if (this.filter_enabled) {
        return 'col-md-9 col-sm-12';
      } else {
        return 'col-sm-12';
      }
    }
  }),
  mounted: function mounted() {
    var _this3 = this;
    Somos1Service.somos1_agreement().then(function (response) {
      _this3.agreement_text = response.data;
    });
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('app', ['setShowLoading'])), {}, {
    getReports: function getReports() {
      var _this4 = this;
      this.setShowLoading(true);
      var params = {
        is_admin: this.userHasRole(this.rolesINCA.INSIGHTS_ADMIN),
        section: this.EMPRESAS,
        company_code: this.company_code
      };
      Somos1Service.getReportsAssignments(params).then(function (response) {
        // response.data = response.data.filter(item => item.report.section === 'Empresas')
        console.log(' response.data', response.data);
        _this4.items = response.data;
        _this4.keyDashboardsList += 1;
      }).finally(function () {
        _this4.setShowLoading(false);
      });
    },
    openAgreement: function openAgreement() {
      this.$refs.agreement.onOpen();
    },
    onVolver: function onVolver() {
      this.decline = false;
      this.openAgreement();
    },
    onAccept: function onAccept() {
      var _this5 = this;
      this.$refs.agreement.onClose();
      var token = this.genToken();
      var data = {
        'token': token,
        'email': userInfo.email,
        'domain': userInfo.domain
      };
      SecurityService.sendToken(data).then(function (response) {
        _this5.$refs.tokencomponent.onOpen();
      });
    },
    onClose: function onClose() {
      this.decline = true;
    },
    sendToken: function sendToken(token) {
      var _this6 = this;
      var data = {
        'token': token,
        'email': userInfo.email,
        'domain': userInfo.domain
      };
      SecurityService.verifyToken(data).then(function (response) {
        if (!response.data) {
          tasks.toast.error('Token incorrecto, ingréselo nuevamente.');
        } else {
          tasks.toast.success('Token correcto.');
          _this6.$refs.tokencomponent.onClose();
          _this6.userInfo.somos1_agreement = true;
          _this6.has_accepted = true;
          location.reload();
          _this6.getReports();
        }
      });
    },
    onVer: function onVer(item) {
      console.log(item);
      var roles = userInfo.userRoles;
      var encontradoUser = roles.includes("insights_user_somos1");
      var encontradoBusiness = roles.includes("insights_business_user");
      var rol = encontradoUser ? encontradoBusiness ? "insights_user_somos1" : "insights_user_somos1" : encontradoBusiness ? "insights_business_user" : null;
      console.log("rol:", rol);
      var report = item.report;
      if (this.$gtm.enabled() && window.dataLayer) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: GA_EVENTS.CLICK_REPORT,
          region: _typeof(report.region) === 'object' ? report.region.region : report.region,
          type: 'business_report',
          company_report: this.$route.query.company_code,
          company_code: this.companyCode,
          hash_email: this.stringToHash(userInfo.email),
          rol: rol,
          'module': 'customer_insights',
          report_id: item.report_id
        });
      }
      this.$router.push({
        name: 'Somos1',
        params: {
          report_id: item.report.document_id,
          no_require_agreement: true,
          link: 'companies',
          title: 'Empresas'
        }
      });
    },
    genToken: function genToken() {
      var token = Math.floor(Math.random() * 9000) + 1000;
      return token.toString();
    }
  })
};